import { Reveal, Eyebrow } from "../components/site/Reveal";
import { ClientMarquee } from "../components/site/Marquee";
import { CTABand } from "../components/site/CTABand";
import { CLIENTS, SECTORS } from "../lib/content";

export default function Experience() {
  return (
    <>
      <section className="relative overflow-hidden border-b border-slate-200">
        <div className="absolute inset-0 grid-bg" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Reveal>
            <Eyebrow testId="experience-eyebrow">Selected engagement experience</Eyebrow>
            <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1F44] max-w-3xl leading-[1.08]">
              Specialist roles. <span className="text-blue-700">Established organisations.</span>
            </h1>
            <p className="mt-7 text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl">
              For more than 10 years we have partnered with Australian organisations across retail,
              government, not-for-profit, utilities, banking & insurance and education. Examples of
              contract and contingent workforce engagements supplied in our capability statement.
            </p>
          </Reveal>
        </div>
      </section>

      <ClientMarquee speed="55s" />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CLIENTS.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 0.08}>
              <div
                data-testid={`client-card-${i}`}
                className="h-full min-h-[140px] flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-6 py-10 text-center transition-all duration-300 hover:border-blue-600/40 hover:bg-blue-50/40"
              >
                {c.logo ? (
                  <img src={c.logo} alt={c.name} className="max-h-20 w-auto max-w-[220px] object-contain" />
                ) : (
                  <span className={`text-xl sm:text-2xl text-slate-700 ${c.style}`}>{c.name}</span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-xs text-slate-600 max-w-xl" data-testid="experience-disclaimer">
          Selected recruitment and placement experience; no endorsement by the organisations listed is
          implied.
        </p>

        <Reveal className="mt-20">
          <Eyebrow testId="sectors-eyebrow">Sectors we support</Eyebrow>
          <div className="mt-8 flex flex-wrap gap-3">
            {SECTORS.map((s) => (
              <span
                key={s}
                data-testid={`sector-chip-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="rounded-full border border-slate-300 px-5 py-2.5 text-sm text-slate-600 transition-colors duration-200 hover:border-blue-600/60 hover:text-blue-700"
              >
                {s}
              </span>
            ))}
          </div>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
